import React from 'react';
import { Segment, Dimmer, Header } from 'semantic-ui-react';
import { SemanticPlaceholder } from './Placeholder';

export function YoureDoingSomeThingWrong({
  repeat = 4,
  withHeader = true,
  withSubheader = true,
  tip = '',
  ...rest
}) {
  return (
    <Dimmer.Dimmable
      className="youre-doing-something-wrong"
      as={Segment}
      blurring
      dimmed={true}
      basic
      {...rest}
    >
      <Dimmer active={true} inverted>
        <Header as="h5">
          {`You're probably doing something wrong`}
          {withSubheader && (
            <Header.Subheader as="h6">
              {`Please follow our `}
              <a
                href="https://ar.ebrd.belovdigital.dev/readme/"
                target="_blank"
                rel="noopener noreferrer"
              >
                instructions
              </a>
              {` to make correct content flow`}
            </Header.Subheader>
          )}
          {tip !== '' && <small>{`Tip: ${tip}`}</small>}
        </Header>
      </Dimmer>
      <SemanticPlaceholder repeat={repeat} withHeader={withHeader} />
    </Dimmer.Dimmable>
  );
}
